import { LoaderMessage as LoaderMessageComponent } from "../components/loaderMessage/loaderMessage";

interface LoaderMessageProps {
  message: string;
}

export const LoaderMessage = ({ message }: LoaderMessageProps) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%",
        gap: "1rem",
      }}
    >
      <LoaderMessageComponent message={message} />
    </div>
  );
};
